import React from 'react';

const ProgressTracker = ({ currentStep }) => {
  const stepLabels = ['', 'Cita', 'Paciente', 'Documentos', 'Información', 'Confirmar'];

  return (
    <div className="progress-card card_background">
      <h3 className="section-titleeee">Progreso de agendamiento</h3>
      <div className="progress-steps">
        {[1, 2, 3, 4, 5].map(step => (
          <div key={step} className={`step-indicator ${currentStep === step ? 'active' : ''}`}>
            <div className="step-number">{step}</div>
            <div className="step-label">
              {currentStep === step ? stepLabels[step] : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressTracker;